import { ErrorType } from '@fabric-app/business/errors/errors.types';
import type { IntegrationProvider } from '@fabric-app/types/connections';
import { MAX_GOOGLE_FOLDER_SYNC_ITEMS_COUNT } from '../googleDrive/constants';

export const supportedIntegrationProviders: Readonly<IntegrationProvider[]> = [
  'google_drive',
  'dropbox',
  'gmail',
];
export const integrationProviderDisplayName: Record<IntegrationProvider, string> = {
  google_drive: 'Google Drive',
  dropbox: 'Dropbox',
  gmail: 'Gmail',
};

export const mapProviderToUrlType: Record<IntegrationProvider, string> = {
  google_drive: 'google-drive',
  dropbox: 'dropbox',
  gmail: 'gmail',
};

export const MIRROR_MESSAGE_MAP = {
  err_integration_exceeded_resource_volume: `Your connection contains more than ${MAX_GOOGLE_FOLDER_SYNC_ITEMS_COUNT} items. Try reducing the amount and then resync.`,
  err_integration_remote_deleted:
    'The remote connection has been deleted or you no longer have access to it.',
  [ErrorType.EXCEEDS_STORAGE_LIMIT]:
    'You have exceeded your storage limit. Upgrade your plan or free up some space, then resume the sync.',
  [ErrorType.EXCEEDS_CREDIT_LIMIT]:
    'You have exceeded your credit limit. Upgrade your plan to resume sync.',
};

export const getTransformedMirrorRegistryMessage = (
  message?: string | null,
): string | null | undefined => {
  if (message && message in MIRROR_MESSAGE_MAP) {
    return MIRROR_MESSAGE_MAP[message as keyof typeof MIRROR_MESSAGE_MAP];
  }

  return message;
};
